import { Modal } from "antd";
import Toolbar from "components/Toolbar/index";
import { Flex, Box, Text, VStack } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import { useState, useEffect } from "react";
import DateRangePicker from "components/Input/DateRangePicker/index";
import SelectBaseAntd from "components/Input/SelectBaseAntd";
import { TipoDestinoEnum } from "core/features/documentos/enums/index";
import { useRegrasTenant } from "core/features/tenants/tenants.context";
import SelectTenant from "components/Input/SelectTenant";

interface ModalFiltroMensagensProps {
  open: boolean;
  onClose: () => any;
  showFilter?: boolean;
  filtro: FiltroMensagens;
  onChangeFiltro: (filtro: Partial<FiltroMensagens>) => any;
}
type FiltroMensagens = {
  dataInicio?: string;
  dataFim?: string;
  tipoDestino?: string;
  tenantsIds?: string[];
};

export default function ModalFiltroMensagens({
  filtro,
  onClose,
  showFilter,
  open,
  onChangeFiltro,
}: ModalFiltroMensagensProps) {
  const { useSubtenantsViews } = useRegrasTenant();

  const [localFiltro, setLocalFiltro] = useState<FiltroMensagens>(filtro);

  useEffect(() => {
    if (!open) {
      setLocalFiltro(filtro);
    }
  }, [open, filtro]);

  const onReset = () => {
    onChangeFiltro({
      dataInicio: undefined,
      dataFim: undefined,
      tipoDestino: undefined,
      tenantsIds: [],
    });
  };
  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      closable={false}
      className="antd-custom-header"
      width="550px"
      title={<Toolbar title="Filtrar" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            filtroValue={undefined}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      <VStack spacing="1rem" w="100%">
        {useSubtenantsViews && (
          <Flex w={"100%"} flexDirection="column">
            <Text mb="5px">Condomínios</Text>
            <SelectTenant
              mode="multiple"
              onChange={(tenantsIds) => {
                setLocalFiltro((state) => ({ ...state, tenantsIds }));
              }}
              value={localFiltro.tenantsIds}
              allowClear
              placeholder="Todos os condomínios"
            />
          </Flex>
        )}
        <Box w={"100%"} sx={{ "&> div ": { bg: "white !important" } }}>
          <Text mb="5px">Período</Text>
          <DateRangePicker
            onChange={(dataInicio, dataFim) => {
              setLocalFiltro((v) => ({ ...v, dataInicio, dataFim }));
            }}
            value={{
              dataInicio: localFiltro?.dataInicio,
              dataFim: localFiltro?.dataFim,
            }}
          />
        </Box>
        {!showFilter && (
          <Box w={"100%"}>
            <Text mb="5px">Tipo de destino</Text>
            <SelectBaseAntd
              size="large"
              bg="white"
              allowClear
              onClear={() =>
                setLocalFiltro((prev) => ({ ...prev, tipoDestino: undefined }))
              }
              value={localFiltro.tipoDestino}
              onChange={(v) =>
                setLocalFiltro((prev) => ({ ...prev, tipoDestino: v }))
              }
              style={{ background: "white !important", minWidth: "9rem" }}
              placeholder="Destino"
              options={tipoDestinoOptions.map((item) => ({
                label: item.label,
                value: item.value || "",
              }))}
            />
          </Box>
        )}
      </VStack>
    </Modal>
  );
}

const tipoDestinoOptions: { label: string; value: TipoDestinoEnum }[] = [
  { label: "Portaria", value: TipoDestinoEnum.Portaria },
  { label: "Todas unidades", value: TipoDestinoEnum.TodasUnidades },
  { label: "Grupo de unidades", value: TipoDestinoEnum.UmGrupoUnidades },
  { label: "Uma unidade", value: TipoDestinoEnum.UmaUnidade },
  { label: "Email", value: TipoDestinoEnum.Email },
  { label: "Uma pessoa", value: TipoDestinoEnum.UmaPessoa },
  { label: "Um cargo", value: TipoDestinoEnum.UmCargo },
];
